var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurityIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18489",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18489",
    transform: "translate(-33 -547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icons8-user-shield",
    d: "M10.718,1,3,4.43V9.576a10.65,10.65,0,0,0,7.718,10.291A10.65,10.65,0,0,0,18.436,9.576V4.43Zm0,4.288A2.573,2.573,0,1,1,8.145,7.861,2.576,2.576,0,0,1,10.718,5.288Zm0,12.809a9.236,9.236,0,0,1-5.065-4.485,9.808,9.808,0,0,1,5.065-1.464,9.815,9.815,0,0,1,5.066,1.464A9.24,9.24,0,0,1,10.718,18.1Z",
    transform: "translate(32.282 546.567)",
    fill: "#A59785"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_11148",
    "data-name": "\\u9577\\u65B9\\u5F62 11148",
    width: 20,
    height: 20,
    transform: "translate(33 547)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityIcon);
export default __webpack_public_path__ + "static/media/security_icon.eda257efce383ee6a53471d7a508ff1e.svg";
export { ForwardRef as ReactComponent };